import { CircularProgress } from '@mui/material';
import _ from 'lodash';
import { TitledPage } from '@client/new/components/Misc';
import { AsyncRenderer } from '@client/new/components/AsyncRenderer/AsyncRenderer';
import auth from '@client/components/auth';
import { EnableDirectMessage } from './view/EnableDirectMessage';
import {
  InboxViewModel,
  useInboxViewModel,
} from './viewModel/useInbox.viewModel';
import { InboxTabs } from './view/InboxTabs';

type InboxPageProps = {
  params: {
    influencerId: string;
  };
};

export const InboxPage = (props: InboxPageProps) => {
  const influencerId = props.params.influencerId
    ? parseInt(props.params.influencerId)
    : auth.getUser().influencerId;
  const viewModel = useInboxViewModel({ influencerId });

  return (
    <AsyncRenderer
      data={viewModel}
      loadRender={
        <TitledPage title="Direct Messages">
          <div className="flex justify-center items-center">
            <CircularProgress />
          </div>
        </TitledPage>
      }
      renderer={(data) => (
        <TitledPage title="Direct Messages">
          <Inbox {...data} />
        </TitledPage>
      )}
    />
  );
};

const Inbox = (p: InboxViewModel) => {
  if (!p.isMessagingEnabled) {
    return <EnableDirectMessage {...p.enableDM} />;
  }

  return <InboxTabs {...p} />;
};
